export default {
  initialized: false,
  items: [],
  item: {},
  links: []
};
